import { Box, MenuItem, menuItemClasses, MenuList } from "@mui/material";

import { workspaces } from "../data";
import { Workspace } from "../types";
import { WorkspaceAvatar } from "./WorkspaceAvatar";
import { WorkspaceLabel } from "./WorkspaceLabel";

type WorkspaceListProps = {
  changeWorkspace: (workspace: Workspace) => void;
  selectedWorkspace: Workspace;
};

export const WorkspaceList = ({
  changeWorkspace,
  selectedWorkspace,
}: WorkspaceListProps) => {
  return (
    <MenuList
      disablePadding
      sx={{
        [`& .${menuItemClasses.root}`]: {
          [`&.${menuItemClasses.selected}`]: {
            bgcolor: "action.selected",
            fontWeight: "fontWeightSemiBold",
          },
          borderRadius: 0.75,
          gap: 1.5,
          p: 1.5,
        },
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        p: 0.5,
        width: 260,
      }}
    >
      {workspaces.map((option) => (
        <MenuItem
          key={option.id}
          onClick={() => changeWorkspace(option)}
          selected={option.id === selectedWorkspace?.id}
        >
          <WorkspaceAvatar alt={option.name} src={option.logo} />

          <Box component="span" sx={{ flexGrow: 1 }}>
            {option.name}
          </Box>

          <WorkspaceLabel label={option.label} />
        </MenuItem>
      ))}
    </MenuList>
  );
};
